var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-85"},[_c('div',{staticClass:"wrapper-merci center-align col l12"},[_c('h4',{staticClass:"center-align"},[_c('span',{ref:"messageFormRef",staticClass:"fw-400 fs-12 center-align",attrs:{"id":"msgToShow"},domProps:{"innerHTML":_vm._s(_vm.message)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }